export default {
    state: {
        shareDialog: false,
        shareText: '',
        shareClientId: null,
    },
    mutations: {
        setShareDialog(state, value) {
            state.shareDialog = value;
        },
        setShareText(state, value) {
            state.shareText = value;
        },
        setShareClientId(state, value) {
            state.shareClientId = value;
        },
    },
    actions: {
        setShareDialog({ commit }, value) {
            commit('setShareDialog', value);
        },
        setShareText({ commit }, value) {
            commit('setShareText', value);
        },
        setShareTextAndDialog({ commit }, value) {
            commit('setShareText', value);
            commit('setShareDialog', true);
        },
    },
    getters: {
        getIsoDateTimezaone: () => (date1) => {
            let date = new Date(date1);
            return new Date(
                date.getTime() - date.getTimezoneOffset() * 60000
            ).toISOString();
        },
        decodeHTML: () => (html) => {
            const txt = document.createElement('textarea');
            txt.innerHTML = html;
            return txt.value;
        },
        getLarguraTela: () => {
            return window.innerWidth;
        },
        getShareDialog: (state) => {
            return state.shareDialog;
        },
        getShareText: (state) => {
            return state.shareText;
        },
        getShareClientId: (state) => {
            return state.shareClientId;
        },
    }
}